// SkuMasterSettings — /settings/sku-master
// 品番マスター管理。ユーザー指示（2026-08）で情報アーキテクチャを簡素化:
//   保持: 品番ルール / ユニット / 空き番号管理（番号状態・カウンター・履歴）
//   UIから撤去: マスターデータ取り込み・大分類・中分類・カウンター（空き番号管理に統合）
// ※ 大分類/中分類のデータとAPIは既存の品番ルールが参照するため削除していない。
// Design Language v1.1: フラットな PageHeader + 標準タブ（グラデーションバナー廃止）
import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { PageHeader } from '@/components/enterprise/PageHeader';
import { useAuth, isAdmin } from '@/auth/AuthContext';
import SkuTemplatesCardLazy from './SkuTemplatesCard';
import SkuAvailabilityCardLazy from './SkuAvailabilityCard';
import SkuUnitCodesCardLazy from './SkuUnitCodesCard';
import SkuPrefixCollisionsCard from './SkuPrefixCollisionsCard';
import NumberPolicyCard from './NumberPolicyCard';

export default function SkuMasterSettings() {
  const { user } = useAuth();
  const admin = isAdmin(user);
  const [tab, setTab] = useState('templates');
  // iter_150 · カウンター → 品番ルール drill-down は空き番号管理から呼ばれる
  const [tplFilterOverride, setTplFilterOverride] = useState(null);
  const openTemplatesFor = (tplCode) => {
    setTplFilterOverride(tplCode);
    setTab('templates');
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6" data-testid="sku-master-page">
      <PageHeader
        testid="sku-master-header"
        title="品番マスター管理"
        description={admin
          ? '品番ルール・ユニット図番・番号状態（予約/発行済/解放/再利用可）を一元管理'
          : '品番ルールを閲覧・利用できます（マスター管理は管理者のみ）'}
      />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="sku-tabs-list">
          <TabsTrigger value="templates" data-testid="sku-tab-templates">品番ルール</TabsTrigger>
          {admin && <TabsTrigger value="units" data-testid="sku-tab-units">ユニット</TabsTrigger>}
          <TabsTrigger value="availability" data-testid="sku-tab-availability">空き番号管理</TabsTrigger>
        </TabsList>
        <TabsContent value="templates" className="mt-4 space-y-4">
          {/* 2026-06 · 台帳ごとの既定の採番ルール（登録フォームが最初に選ぶ採り方） */}
          {admin && <NumberPolicyCard />}
          <SkuTemplatesCardLazy initialFilter={tplFilterOverride} onFilterConsumed={() => setTplFilterOverride(null)} />
          {admin && <SkuPrefixCollisionsCard />}
        </TabsContent>
        <TabsContent value="availability" className="mt-4">
          <SkuAvailabilityCardLazy onOpenTemplate={openTemplatesFor} />
        </TabsContent>
        {admin && <TabsContent value="units" className="mt-4"><SkuUnitCodesCardLazy /></TabsContent>}
      </Tabs>
    </div>
  );
}
